import styled from "styled-components"

interface AdminCard {
  bg?: string
  textColor?: string
}

export const AdminCard = styled.div<{ bg?: string, textColor?: string }>`
  width: 100%;
  height: 320px;
  background-color: ${(p) => p.bg};
  color: ${(p) => p.textColor};
  border-radius: 34px;
  border: 0;
  box-shadow: 0px 3px 6px #00000029;
  display: flex;
  flex-direction: column;
  justify-content: center;
  opacity: 1;

  @media (max-width: 780px) {
    width: 100%;
    height: 280px;
    margin-bottom: 10px;
  }
`

export const AdminCardHeader = styled.div`
  width: 100%;
  height: 25%;
  display: flex;
  letter-spacing: 0.92px;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  font-size: clamp(1.9rem, 2.5vw, 1.9rem);
  margin-bottom: 0;
  font-family: MontserratRegular;
`

export const AdminCardButtons = styled.div`
  width: 100%;
  height: 35%;
  background-color: transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
`

interface AdminButton {
  textColor?: string
}

export const AdminButton = styled.button`
  width: 10rem;
  height: 2.4rem;
  display: block;
  background-color: transparent;
  color: ${(p: AdminButton) => p.textColor};
  border-radius: 25px;
  border: 2px solid #707070;
  margin: 3px;
  font-size: clamp(0.9rem, 2.5vw, 0.9rem);
  font-weight: 700;
  font-family: MontserratRegular;
`

interface AdminCardScores {
  quantity: number
}

export const AdminCardScores = styled.div`
  width: 100%;
  height: 38%;
  display: grid;
  grid-template-columns: ${(p: AdminCardScores) => `repeat(${p.quantity}, 1fr)`};
  grid-gap: 3px;
  padding: 0.2rem 0.4rem;
  align-items: center;
  justify-content: center;
  justify-items: center;
  overflow-x: auto;

  &::-webkit-scrollbar {
    display: none;
  }
`
interface ScoreCard {
  quantity: number
}

export const ScoreCard = styled.div`
  border-radius: 23px;
  width: ${(p: ScoreCard) => (p.quantity === 1 ? "50%" : "95%")};
  height: 105px;
  box-shadow: 0px 3px 6px #00000029;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-family: MontserratRegular;

  @media (max-width: 780px) {
    height: 95px;
  }
`

interface ScoreCardText {
  textColor?: string
}

export const ScoreCardText = styled.p`
  font-size: clamp(0.9rem, 2.5vw, 0.9rem);
  letter-spacing: 0px;
  color: ${(p: ScoreCardText) => p.textColor};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  text-align: center;
  font-weight: 700;
  font-family: MontserratRegular;
`

interface ScoreCardCounter {
  textColor?: string
}

export const ScoreCardCounter = styled.h3`
  color: ${(p: ScoreCardCounter) => p.textColor};
  font-size: clamp(1.9rem, 2.5vw, 1.9rem);
  font-family: MontserratRegular;
  font-weight: 600;
`
